import React, { useState, useEffect } from "react";
import Button from "../../common/Button/Button";
import EducationGallery from "./EducationGallery";
import WorkGallery from "./WorkGallery";
import CommunityGallery from "./CommunityGallery";
import SoccerGallery from "./SoccerGallery";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Activity.css";

import img1 from "../../images/activities/education/img (23).jpg";
import img2 from "../../images/activities/work/img (8).JPG";
import img3 from "../../images/activities/education/img (21).jpg";
import img4 from "../../images/activities/humanitarian/img (35).jpg";



const Activity = () => {
  const [openEducation, setOpenEducation] = useState(false);
  const [openWork, setOpenWork] = useState(false);
  const [openCommunity, setOpenCommunity] = useState(false);
  const [openSoccer, setOpenSoccer] = useState(false);

  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  const openEducationGallery = () => setOpenEducation(true);
  const openWorkGallery = () => setOpenWork(true);
  const openCommunityGallery = () => setOpenCommunity(true);
  const openSoccerGallery = () => setOpenSoccer(true);

  const activities = [
    {
      title: "Education",
      description: "We provide comprehensive educational assistance by supplying schools with essential supplies, modern technology, clothing, and nutritious food for students. We maintain teacher and staff salaries to ensure quality education continues. Our infrastructure projects include upgrading facilities and building new resources. Last year, we built a modern library from scratch for an elementary school of 1,200 students in Kabul, equipping it with computers, televisions, and thousands of books.",
      image: img1,
      imageAlt: "Children studying in a library",
      imageCaption: "Modern library for 1,200 students in Kabul",
      icon: "📚", // Emoji instead of FontAwesome icon
      delay: 100,
      onClick: openEducationGallery
    },
    {
      title: "Work Program",
      description: "Our innovative work program creates economic opportunities for students' families, helping break the cycle of poverty. We hire family members to repair and paint classrooms, and support small businesses like bakeries that produce pastries and cookies. These income-generating activities ensure students don't need to work after school, allowing them to focus on their education while their families maintain financial stability.",
      image: img2,
      imageCaption: "Creating economic opportunities for families",
      icon: "💼", // Emoji instead of FontAwesome icon
      delay: 200,
      onClick: openWorkGallery
    },
    {
      title: "Indoor Soccer Team",
      description: "Managed by Atiq Raheen, our indoor soccer program serves children in grades four through six, providing vital physical education and team-building experiences. Students actively participate in regular training sessions and competitive tournaments. With a monthly investment of $200, we're fostering discipline, teamwork, and healthy habits while giving children a safe space to play and grow.",
      image: img3,
      imageAlt: "Children playing indoor soccer",
      imageCaption: "Team-building through sports",
      icon: "⚽", // Emoji instead of FontAwesome icon
      delay: 300,
      onClick: openSoccerGallery
    },
    {
      title: "Humanitarian Aid",
      description: "Our humanitarian efforts address immediate needs in the community, especially during challenging times. During the COVID-19 pandemic, we provided essential food and clothing to struggling families. We partnered with local small businesses to supply protective face masks to every student. We continue to respond to emergencies and provide support where it's needed most, ensuring no family is left behind.",
      image: img4,
      imageAlt: "Distributing aid to community members",
      imageCaption: "Emergency support for families in need",
      icon: "🤝", // Emoji instead of FontAwesome icon
      delay: 400,
      onClick: openCommunityGallery
    }
  ];

  return (
    <div>
      {openEducation && (
        <EducationGallery isOpen={openEducation} setIsOpen={setOpenEducation} />
      )}
      {openWork && <WorkGallery isOpen={openWork} setIsOpen={setOpenWork} />}
      {openCommunity && (
        <CommunityGallery isOpen={openCommunity} setIsOpen={setOpenCommunity} />
      )}
      {openSoccer && (
        <SoccerGallery isOpen={openSoccer} setIsOpen={setOpenSoccer} />
      )}
      
      <h1 className="activity" data-aos="fade-down">
        <span className="activity-title-text">What We Do</span>
      </h1>
      
      <div className="activity-container">
        <div className="activity-cards-container">
          {activities.map((activity, index) => (
            <div 
              key={index}
              className="activity-card" 
              data-aos="fade-up"
              data-aos-delay={activity.delay}
            >
              <div className="activity-card-image">
                <img 
                  src={activity.image} 
                  alt={activity.imageAlt}
                  loading="lazy"
                />
                <div className="image-caption">
                  <span className="caption-icon">{activity.icon}</span> {activity.title}
                </div>
                <div className="image-overlay">
                  <p>{activity.imageCaption}</p>
                </div>
              </div>
              
              <div className="activity-card-content">
                <h2>{activity.title}</h2>
                <p className="activity-card-description">
                  {activity.description}
                </p>
                <div className="activity-card-actions">
                  <Button
                    className="btns"
                    buttonStyle="btn--solid"
                    buttonSize="btn--small"
                    onClick={activity.onClick}
                  >
                    <span className="btn-icon">📸</span> VIEW GALLERY
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Activity;
